export default {
  ACTIVE: "Aktiv",
  INACTIVE: "Inaktiv",
  DONE: "Abgeschlossen"
};
